import {Routes} from '@angular/router';
import {AdministrationDataPortalComponent} from './administration-data-portal.component';

export const ADMINISTRATION_DATA_PORTAL_ROUTES: Routes = [
  {
    path: '',
    children: [
      {path: '', component: AdministrationDataPortalComponent},
      {path: ':stepId', component: AdministrationDataPortalComponent}
    ]
  }
];
